const fetch = require('isomorphic-unfetch');
const checkErrors = require('../utils/errorTracker');

async function makeHttpCall(url, method, reqBody, inputOptions = {}) {
  const commonHeaders = { 'Content-Type': 'application/json' };
  const { otpFlow, ...restInputOptions } = inputOptions;
  const options = {
    ...restInputOptions,
    headers: { ...commonHeaders, ...(restInputOptions.headers || {}) },
  };
  try {
    const response = await fetch(url, {
      method,
      ...(reqBody ? { body: JSON.stringify(reqBody) } : {}),
      ...options,
    });
    const responseBody = response.status === 204 ? {} : await response.json();

    checkErrors(response, url, responseBody, otpFlow);
    return { responseBody, response };
  } catch (_ignored) {
    return undefined;
  }
}

function get(url, options) {
  return makeHttpCall(url, 'GET', null, options);
}

function post(url, reqBody, options) {
  return makeHttpCall(url, 'POST', reqBody, options);
}

function put(url, reqBody, options) {
  return makeHttpCall(url, 'PUT', reqBody, options);
}

const http = { get, post, put };

module.exports = http;
